export const micrositeTemplateFolderName = "template";
